import React, { FunctionComponent } from 'react';

import CardBox from '../CardBox';
import { Address } from '../../requests/caipirinha-api/interfaces/order.interface';
import Title from '../Title';
import Warning from '../Warning';
import IcCar from '../../assets/icons/ic_car.svg';

interface Props {
  address: Address;
  warning?: boolean;
}

const AddressDelivery: FunctionComponent<Props> = ({
  address,
  warning = true,
}) => {
  return (
    <>
      <Title icon={IcCar} small>
        Endereço de entrega
      </Title>
      <CardBox>
        <h4>
          {address.street} - {address.number}
        </h4>
        <p className="large">
          {address.neighbourhood}, {address.city}, {address.state}
        </p>
        {address.complement && address.complement.length > 0 && (
          <p className="large">Complemento: {address.complement}</p>
        )}
        <p className="large">CEP: {address.zipCode}</p>
      </CardBox>

      {warning && (
        <Warning>
          Caso tenha erro no pedido ou no endereço de entrega, por favor entre
          em contato com o vendedor.
        </Warning>
      )}
    </>
  );
};

export default AddressDelivery;
